import { combineReducers, Reducer } from 'redux';

import * as types from './personal-notes.types';
import * as constants from './personal-notes.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IPersonalNotesPageState = {
  personalNotesIds: [],
};

const personalNotesReducer: Reducer<
  types.IPersonalNotesPageState['personalNotesIds'],
  types.IStorePersonalNotes | types.IClearPersonalNotes
> = (state = initialState.personalNotesIds, action) => {
  if (isActionOfType<types.IStorePersonalNotes>(action, constants.STORE_PERSONAL_NOTES)) {
    return action.payload;
  } else if (isActionOfType<types.IClearPersonalNotes>(action, constants.CLEAR_PERSONAL_NOTES)) {
    return initialState.personalNotesIds;
  }

  return state;
};

export const personalNotesPageReducer: Reducer<
  types.IPersonalNotesPageState,
  types.IPersonalNotesPageAction
> = combineReducers({
  personalNotesIds: personalNotesReducer,
});
